import { TThunkAction } from '../../types/redux';
import { outerRequest, EMethod } from '../../utils/outerRequest';
import { ISuggestions, EPartsLower, EGender } from '../../types/fio';

import { MCS_NAME } from '../../constants/mcsName';
import { sendTelemetryCounter } from '../../services/telemetry';
import { getRequestUrl } from './utils';

const defaultData: ISuggestions = {
  suggestions: [],
};

export function getFIOSuggestRequest(query: string, currentPartFIO: EPartsLower, gender: EGender): TThunkAction {
  return (dispatch, getState, context) => {
    const { httpApi, config, logger } = context;
    const token = config.get<string>('dadataFioSuggest.token');

    if (!token) {
      logger.warning('Invalid fio suggest dadata api token');

      return defaultData;
    }

    const url = getRequestUrl(query, currentPartFIO, gender, token);

    return outerRequest({
      method: EMethod.GET,
      url,
    })
      .then((response: ISuggestions) => {
        sendTelemetryCounter({
          httpApi,
          key: `${MCS_NAME}.dadata-fio-suggest.200`,
        });

        return response;
      })
      .catch(error => {
        logger.warning('Invalid fio suggest dadata api request', error);

        return defaultData;
      });
  };
}
